import { render } from "./construction.vue?vue&type=template&id=0eefcbd0&scoped=true"
import script from "./construction.vue?vue&type=script&lang=js"
export * from "./construction.vue?vue&type=script&lang=js"

import "./construction.vue?vue&type=style&index=0&id=0eefcbd0&scoped=true&lang=css"

import exportComponent from "D:\\Web\\hkjt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eefcbd0"]])

export default __exports__